import BonosApi from '../../apis/Bonos';

export default {
    namespaced: true,
    state: {
        bonos: [],
        bonoActivo: [],
        bonoSelected: null
    },
    mutations: {
        set_bonos (state, bonos) {
            state.bonos = bonos
        },
        set_bonosActivos (state, bonoActivo) {
            state.bonoActivo = bonoActivo
        },
        set_BonoSelected (state, data) {
            state.bonoSelected = data;
        },
        replace_bono_item (state, data) {
            console.log(data)
            state.bonoActivo.splice(data.index, 1, data.item);
        }
    },
    actions: {
        async getBonos({commit, dispatch}, filters) {
            return await BonosApi.get_all(filters)
                        .then( response => {
                            ///console.log(response.data);
                            commit('set_bonos', response.data)
                        })
                        .catch( error => {
                            if (error.response?.status === 401) return null
                            dispatch('notifications/store_notification', {
                                type: 'error',
                                message: 'Ocurrió un error al listar registros, vuelva a intentarlo.'
                            }, {root: true});
                        })
        },
        async store({dispatch}, bono) {
            return await BonosApi.store(bono)
                            .then( response => {
                                dispatch('notifications/store_notification', {
                                    type: 'success',
                                    message: 'El registro se realizó de forma correcta.'
                                }, {root: true});
                                dispatch('getBonos');
                            })
                            .catch( error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al registrar, vuelva a intentarlo.'
                                }, {root: true});
                            })
        },
        async update({dispatch}, bono) {
            return await BonosApi.update(bono)
                            .then( response => {
                                dispatch('notifications/store_notification', {
                                    type: 'success',
                                    message: 'La actualización se realizó de forma correcta'
                                }, {root: true});
                                dispatch('getBonos');
                            })
                            .catch( error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al actualizar, vuelva a intentarlo.'
                                }, {root: true});
                            })
        },
        async change_status({dispatch}, bono) {
            let action = (bono.activo) ? 'inactivación' : 'activación';
            return await BonosApi.change_status(bono)
                            .then( response => {
                                dispatch('notifications/store_notification', {
                                    type: 'success',
                                    message: 'La '+ action + ' se relizó de forma correcta.'
                                }, {root: true});
                                dispatch('getBonos')
                            })
                            .catch( error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al realizar la ' + action + ', vuelva a intentarlo.'
                                }, {root: true})
                            })
        },
        async delete({dispatch}, bono) {
            return await BonosApi.delete(bono)
                            .then( response => {
                                dispatch('notifications/store_notification', {
                                    type: 'success',
                                    message: 'La eliminación se realizó de forma correcta.'
                                }, {root: true})
                                dispatch('getBonos')
                            })
                            .catch( error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al eliminar, vuelva a intentarlo.'
                                }, {root: true})
                            })
        },
        async bonoActivos({commit, dispatch}) {
            return await BonosApi.listarActivos()
                            .then( response => {
                                commit('set_bonosActivos', response.data)
                            })
                            .catch( error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al listar registros, vuelva a intentarlo.'
                                }, {root: true});
                            })
        },
        setBonoSelected ({commit}, data) {
            commit('set_BonoSelected', data);
        },
        replaceBonoItem ({commit}, data) {
            console.log(data)
            commit('replace_bono_item', data);
        }
    }
}